import { styled, Modal, SHADOW_LEVEL1 } from '@ori-ui/mui';
import { MenuContentContainer as PbsMenuContent } from '@ori/personal-beauty-store';

import { CSS_DESKTOP_INNER_HEIGHT, CSS_HEIGHT_ANIMATION, DESKTOP_HEIGHT } from '../../constants';
import { basePositionStyles } from '../constants';
import { HEIGHT_BUFFER } from './constants';

export const BurgerMenuContentRoot = styled('div')(() => ({}));

export const StyledPbsMenuContent = styled(PbsMenuContent)({
  marginLeft: '4rem',
  marginTop: '3rem',
});

export const ModalRoot = styled(Modal)(({ theme }) => ({
  ...basePositionStyles,
  zIndex: theme.zIndex.drawer,
  display: 'block',
}));
export const BurgerMenuRoot = styled('aside')<{
  ownerState: { isMobile?: boolean; isDesktop?: boolean };
}>(({ ownerState, theme }) => ({
  backgroundColor: theme.palette.common.white,
  display: 'none',
  transition: `top ${CSS_HEIGHT_ANIMATION}`,

  ...(ownerState.isMobile && {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: 'calc(100% - 45px)',
    position: 'absolute',
    width: 315,
  }),

  ...(ownerState.isDesktop && {
    boxShadow: SHADOW_LEVEL1,
    display: 'flex',
    left: 0,
    minHeight: 590,
    position: 'absolute',
    top: CSS_DESKTOP_INNER_HEIGHT,
  }),
}));

export const BurgerMenuInner = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    width: 'inherit',
    maxHeight: `calc(100vh - ${DESKTOP_HEIGHT}px - ${HEIGHT_BUFFER}px)`,
    overflowX: 'hidden',
    overflowY: 'auto',
  },
}));

export const BurgerMenuContainer = styled('div')({
  display: 'flex',
  height: 54,
  width: '100%',
});
